import React from 'react';
import PropTypes from 'prop-types';
// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';

const Container = styled.div`
  width: 100%;
  background-color: var(--white);
`;

const tabOptionRegularCSS = css`
  border: none;
  cursor: pointer;
  padding: 0;
  background-color: var(--white);
  color: var(--primary500);
  width: 370px;
  height: 64px;
  font: roboto;
  font-size: 1.8rem;
  font-weight: 500;
  border-bottom: 4px solid var(--white);
  ${(props) =>
    !props.isSelected &&
    css`
      &:hover {
        background-color: var(--grey100);
        border-bottom: 4px solid var(--grey100);
      }
    `};
  ${(props) =>
    !!props.isSelected &&
    css`
      cursor: default;
      border-bottom: 4px solid var(--primary500);
    `};
`;

const tabOptionMobileCSS = css`
  font-size: 14px;
`;

const TabOption = styled.button`
  ${tabOptionRegularCSS}
  ${media.lessThan('small')`${tabOptionMobileCSS}`}
`;

const Tab = ({ className, value, options }) => (
  <Container className={className}>
    {options.map((option) => (
      <TabOption
        key={option.value}
        onClick={option.onClick}
        isSelected={value === option.value}
      >
        {option.label}
      </TabOption>
    ))}
  </Container>
);

Tab.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default styled(Tab)`
  display: flex;
  justify-content: center;
`;
